// extracted by mini-css-extract-plugin
export default {"tooltip":"Table_tooltip__9PxyA"};